// Constants

const Brief = {

    /**
     * Initialization
     */
    
    init() {
      
    }
};

export default Brief;



// WEBPACK FOOTER //
// ./src/js/components/brief.js